/**
 * External Dependencies
 */
import 'jquery';
import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/brands';
import { tns } from 'tiny-slider/src/tiny-slider';
import 'jquery-collapse/src/jquery.collapse';
import './magiczoomplus';
import './grid';
import { contains } from 'jquery';
import lozad from 'lozad';

var script = document.createElement('script');
script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBAxo-FpBAsOk7inwq3KNFLfd_zcXRmBM8&callback=initMap';
script.async = true;

$(document).ready(() => {

  // full screen mobile menu
  $('.mobile_nav_trigger').on('click', function(e){
    e.preventDefault(); // prevent default behavior
    $('.mobile_nav').toggleClass('mobile_nav--active').show(); //add nav--active class to nav icon
    $('body').toggleClass('no-scroll'); //disable scroll behind nav
  });

  // clicking on a link or anywhere in the nav closes the menu and enables scroll on body
  $('.mobile_nav li, mobile_nav').on('click', function(){
    setTimeout(function() {
        $('.mobile_nav').removeClass('mobile_nav--active');
        $('body').removeClass('no-scroll');
    }, 300);
  });

  // Front Page Slider
  if ($('body').hasClass('home')) {
    const desktopBannerSlider = tns({
        container: '.maziotis-slider-desktop',
        axis: 'horizontal',
        nav: false,
        autowidth: true,
        viewportMax: 200,
        controls: true,
        controlsText: ['<i class="fas fa-chevron-left fa-2x"></i>', '<i class="fas fa-chevron-right fa-2x"></i>'],
        slideBy: 1,
        autoplay: true,
        autoplayButtonOutput: false,
    });

    const mobileBannerSlider = tns({
        container: '.maziotis-slider-mobile',
        axis: 'horizontal',
        nav: false,
        autowidth: true,
        viewportMax: 200,
        controls: true,
        controlsText: ['<i class="fas fa-chevron-left fa-2x"></i>', '<i class="fas fa-chevron-right fa-2x"></i>'],
        slideBy: 1,
        autoplay: true,
        autoplayButtonOutput: false,
    });

    const brandSlider = tns({
      container: '.brands-slider',
      axis: 'horizontal',
      nav: false,
      // autowidth: true,
      // viewportMax: 200,
      controls: false,
      slideBy: 1,
      autoplay: true,
      autoplayTimeout: 2000,
      autoplayButtonOutput: false,
      responsive: {
        300: {
            items: 1,
        },
        700: {
            items: 2,
        },
        1024: {
            items: 3,
        },
        1280: {
          items: 4
        },
      }
    })
  }

  if ($('body').hasClass('cat-50-id')) {
    $('a[href$="product-category/elastika"]').addClass('active');
  }

  // FAQ Page related methods
  if($('body').hasClass('page-template-template-faq')){

    $('.main h3 ~ p').hide();

    $('<hr>').insertAfter('h3 ~ p');

    $('.main h3').prepend('<i class="fas fa-plus-circle faq_button"></i>');

    $('.main h3').click(function(){
      $(this).find('svg.faq_button').remove();
      $(this).next('h3 ~ p').slideToggle('medium');
      if ( $(this).hasClass('open') ) {
        $(this).prepend('<i class="fas fa-plus-circle faq_button"></i>');
      } else {
        $(this).prepend('<i class="fas fa-times-circle faq_button"></i>');
      }
      $(this).toggleClass('open');
    });
  }

  // Mobile Filter Collapse Toggle
  $('#mobileFilters').collapse({
    // options...
    query: 'div h3',
  });

  $('#toggle').click(function() {
    // $(this.hash).trigger("toggle");
    $('#mobileFilters').trigger('toggle');
  });

  // Magic Zoom Plus options
  let mzOptions = {};
  let mzMobileOptions = {
    zoomMode: "off"
  };

  // Show html content after page is loaded
  (function(H){H.className=H.className.replace(/\bno-js\b/,'js')})(document.documentElement)

  // When the user scrolls down 140px make the desktop_navbar fixed
  window.onscroll = function() {scrollFunction()};

  // Get the navbar
  var navbar = document.getElementById("desktop_navbar");

  // Get the offset position of the navbar
  var sticky = navbar.offsetTop + 80;

  function scrollFunction() {
    if (window.pageYOffset >= sticky) {
      navbar.classList.add('sticky-navbar')
    } else {
      navbar.classList.remove('sticky-navbar')
    }
  }

  // Google maps modal
  $("#btn_modal_map_top").click(function() {
    $("#modal_map").removeClass('hidden').addClass('block');
  });

  $("#btn_modal_map_footer").click(function() {
    $("#modal_map").removeClass('hidden').addClass('block');
  });

  $("#btn_modal_map_contact_footer").click(function() {
    $("#modal_map").removeClass('hidden').addClass('block');
  });

  $("#btn_modal_map_contact").click(function() {
    $("#modal_map").removeClass('hidden').addClass('block');
  });

  $("#btn_modal_close").click(function() {
    $("#modal_map").removeClass('block').addClass('hidden');
  })

  $("#btn_modal_close_mobile").click(function() {
    $("#modal_map").removeClass('block').addClass('hidden');
  })


  // Disable empty search
  $('#searchform').on('submit', function(e){
    if($('#s').val() == ''){
        e.preventDefault();
    }
  });

  $('#searchform_mobile').on('submit', function(e){
    if($('#s').val() == ''){
        e.preventDefault();
    }
  });

  // Lazy Load Google Maps
  // Attach your callback function to the `window` object
  window.initMap = function() {
    // JS API is loaded and available
    var map = new google.maps.Map(document.getElementById('map_desktop'), {
      center: {lat: 38.013594376872284, lng: 23.748578986454103},
      zoom: 16,
      panControl: true,
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: true,
      streetViewControl: true,
      overviewMapControl: true,
      rotateControl: true
    });

    var map_mobile = new google.maps.Map(document.getElementById('map_mobile'), {
      center: {lat: 38.013594376872284, lng: 23.748578986454103},
      zoom: 16,
      panControl: true,
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: true,
      streetViewControl: true,
      overviewMapControl: true,
      rotateControl: true
    });

    var marker = new google.maps.Marker({
      position: {lat: 38.013594376872284, lng: 23.748578986454103},
      map,
      title: "Ελαστικά Μαζιώτης",
    });

    var marker_mobile = new google.maps.Marker({
      position: {lat: 38.013594376872284, lng: 23.748578986454103},
      map,
      title: "Ελαστικά Μαζιώτης",
    });

    marker.setMap(map);
    marker_mobile.setMap(map_mobile);
  };

  // Append the 'script' element to 'head'
  document.head.appendChild(script);


  // Lazy load images
  const observer = lozad('.lozad', {
    rootMargin: '500px 0px',
    threshold: 0.1,
    load: function(el) {
      el.src = el.dataset.src;
    },
  });
  observer.observe();

  if ($('body').hasClass('home')) {

      var modal = document.getElementById('kales_diakopes_modal');

      $('#kales_diakopes_modal_close').click( function() {
          modal.style.opacity = 0;
          modal.style.zIndex = -20;
      })

      $('#kales_diakopes_modal_mobile_close').click( function() {
          modal.style.opacity = 0;
          modal.style.zIndex = -20;
      })
  }

  if ($('body').hasClass('single-product')) {

      var modal = document.getElementById('metavoles_timon_modal');

      $('#metavoles_timon_modal_close').click( function() {
          modal.style.opacity = 0;
          modal.style.zIndex = -20;
      })

      $('#metavoles_timon_modal_mobile_close').click( function() {
          modal.style.opacity = 0;
          modal.style.zIndex = -20;
      })
  }
});
